import React, { lazy } from 'react';
import { PageOrchestrator } from '../orchestrator';

import { useLogin } from './hooks/useLogin';
import { useLoginSubmission } from './hooks/useLoginSubmission';
import { useSocialLogin } from './hooks/useSocialLogin';
import { useEmailFromSearchParams } from './hooks/utility';
import { LoginRecaptcha } from './components/LoginRecaptcha';
import { LoginMarketingConsent } from './components/MarketingConsent';
import RememberedAccountsPage from './remembered-accounts/page';

import { pages } from './cobranding.config';
import { ResetPasswordLink } from './components/ResetPasswordLink';
import { isFedM, isIsolatedCloud } from '../../utilities/env';

const baseLoginPage = lazy(() => import('./BasePage'));

const requiredComponents: Array<string> = [
  useLogin.name,
  useLoginSubmission.name,
  useSocialLogin.name,
  useEmailFromSearchParams.name,
  LoginRecaptcha.name,
  LoginMarketingConsent.name,
  // ResetPasswordLink is not required in IC/FedRAMP environments
  // where the reset password flow is disabled.
  ...(!isIsolatedCloud() && !isFedM() ? [ResetPasswordLink.name] : []),
];

const OrchestratedLoginPage = () => {
  const { shouldShowRememberedAccounts } = useLogin();
  if (shouldShowRememberedAccounts) {
    // cobranding is not currently available for this page. the base page should NOT be modified for cobranding
    return <RememberedAccountsPage />;
  }

  return (
    <PageOrchestrator
      fallback={baseLoginPage}
      pages={pages}
      requiredComponents={requiredComponents}
    />
  );
};

export default OrchestratedLoginPage;
